export const TANSTACK_QUERY_KEY = {
  REFERRAL: {
    ACCOUNT_COMMISSION_SUMMARY: 'REFERRAL_ACCOUNT_COMMISSION_SUMMARY',
    REFERRAL_STATISTICS: 'REFERRAL_STATISTICS',
    REFERRAL_CLAIM_HISTORY: 'REFERRAL_CLAIM_HISTORY',
  },
  ACCESS_CODE: {
    GET_REFERRER_INFO: 'GET_REFERRER_INFO',
    GET_REFERRER_INFO_BY_REFERRAL_CODE: 'GET_REFERRER_INFO_BY_REFERRAL_CODE',
  },
  TRADE: {
    GET_BTC_CONFIRMATION_COUNT: 'GET_BTC_CONFIRMATION_COUNT',
    GET_INDICATIVE_QUOTE_KEY: 'GET_INDICATIVE_QUOTE_KEY',
    GET_TRADE_COMMITMENT_QUOTES: 'GET_TRADE_COMMITMENT_QUOTES',
    GET_TRADE_DETAIL: 'get-trade-detail',
    GET_LIST_TRADE: 'get-list-trade',
  },
  TOKENS: {
    GET_LIST_TOKEN: 'GET_LIST_TOKEN_KEY',
    GET_TOKEN: 'GET_TOKEN_KEY',
  },
  WALLET: {
    GET_WALLET_PUBLIC_KEY: 'get-wallet-public-key',
    GET_BTC_WALLET_ADDRESS: 'get-wallet-address',
    GET_TOKEN_BALANCE: 'get-token-balance',
    LINK_BTC_WALLET: 'LINK_BTC_WALLET',
    TRACK_WALLET_CONNECTED: 'TRACK_WALLET_CONNECTED',
  },
  VAULT: {
    GET_VAULT_DEPOSIT_HISTORY: 'get-vault-deposit-history',
    GET_VAULT_DETAIL: 'get-vault-detail',
  },
  NOTIFY: {
    TELEGRAM_SUBSCRIPTIONS: 'TELEGRAM_SUBSCRIPTIONS',
    GET_SUBSCRIPTION: 'GET_SUBSCRIPTION',
  },
  PROTOCOL_FEE_RATE: 'PROTOCOL_FEE_RATE',
  SETTINGS: {
    TRADE: 'TRADE_SETTING',
  },
  VERIFY_CONTRACT_ADDRESS: 'VERIFY_CONTRACT_ADDRESS',
}
